module.exports = __webpack_public_path__ + "img/pg5-article2-text3.dca86069.png";